import style from './appItemsView.scss';

export default function ($rootScope, $scope, $http, $stateParams, $q, CONFIG) {
    'ngInject';
    $scope.style = style;

    let contentType = $stateParams.contentType;

    let itemEndpoint = `${CONFIG.customUploadUrl}contentful/entries/${$stateParams.id}?sys.type[ne]=${(new Date()).valueOf()}`;

    console.log('endpoint', itemEndpoint);

    let T = $scope.$root.T;
    let contentTypeName = $scope.$root.TC(contentType.name);

    let labelSingle = contentTypeName;
    $scope.labelSingle = labelSingle;

    let formControls = contentType.fields;

    let config = {
        errorMessage: T.HTTP_GET_ERROR_NOTIFICATION + labelSingle
    };

    $http.get(itemEndpoint, config).then(data => {
        let promises = [];

        formControls.forEach(control => {
            let item = data.data.fields[control.id];
            if (item) {
                console.log('item', control, item);
                if (control.type === 'Link') {
                    if (control.linkType === 'Asset') {
                        promises.push($http.get(`${CONFIG.customUploadUrl}contentful/assets/${item.sys.id}`).then(data => {
                            item.__url = data.data.fields.file.url;
                            item.__contentType = data.data.fields.file.contentType;
                        }));
                    } else if (control.linkType === 'Entry') {
                        promises.push($http.get(`${CONFIG.customUploadUrl}contentful/entries/${item.sys.id}`).then(data => {
                            item.__entry = data.data;
                        }));
                    }
                } else if (control.type === 'Array') {
                    if (control.items.type === 'Link') {
                        if (control.items.linkType === 'Entry') {
                            item.forEach(i => {
                                promises.push($http.get(`${CONFIG.customUploadUrl}contentful/entries/${i.sys.id}`).then(data => {
                                    i.__entry = data.data;
                                }));
                            });
                        }
                    }
                }
            }
        });

        $q.all(promises).then(() => {
            $scope.formControls = formControls;
            $scope.item = data.data;

            console.log($scope.item);
        });
    }, (e) => {
        $rootScope.raven.captureException(e);
        $rootScope.raven.showReportDialog();
    });

    $scope.join = value => {
        if (_.isArray(value)) {
            return value.join(', ');
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/views/app.item/appItemsDetailCtrl.js